
import datePickerTemplate from './date-picker.pug';
import moment from 'moment';

const MODULE_NAME = 'datePicker';
const MONTHS = [{ month: 'Január', value: '1' }, { month: 'Február', value: '2' }, { month: 'Március', value: '3' },
{ month: 'Április', value: '4' }, { month: 'Május', value: '5' },
{ month: 'Június', value: '6' }, { month: 'Július', value: '7' }, { month: 'Augusztus', value: '8' },
{ month: 'Szeptember', value: '9' }, { month: 'Október', value: '10' }, { month: 'November', value: '11' }, { month: 'December', value: '12' }];
import {DATE_FORMAT_FROM_SERVER} from  '../constants/consts';
const DATE_FORMAT = 'YYYY-MM-DD';
class DatePickerController {
	constructor($scope, $element, $timeout) {
		'ngInject';
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$element = $element[0];
		this.initWatchers();
	}

	$onInit() {
		this.selectedYear = moment(this.dateModel).year() + '';
		this.days = this.updateDaysList(this.dateModel);
		this.selectedDay = moment(this.dateModel).date() + '';
		this.minimumDate = moment(this.minDate, DATE_FORMAT_FROM_SERVER);
		this.maximumDate = moment(this.maxDate, DATE_FORMAT_FROM_SERVER);
		this.updateYears();
		this.updateMonthList();
		this.selectedMonth = this.months[moment(this.dateModel).month()];
	}

	$onChanges(changeObject) {
		if (changeObject.dateModel && !changeObject.dateModel.isFirstChange()) {
			let dateModel = angular.copy(this.dateModel);
			this.selectedYear = moment(dateModel).year() + '';
			this.selectedMonth = this.months[moment(dateModel).month()];
			this.selectedDay = moment(dateModel).date() + '';
		}
	}

	initWatchers() {
		this.$scope.$watch('$ctrl.selectedYear', (newValue) => {
			if (newValue) {
				this.dateModel = moment(this.dateModel).year(newValue);
				this.updateDaysList(angular.copy(this.dateModel));
				this.onDateChange({date: this.dateModel});
			}
		});
		this.$scope.$watch('$ctrl.selectedMonth', (newValue) => {
			if (newValue) {
				this.dateModel = moment(this.dateModel).month(newValue.value - 1);
				this.updateDaysList(angular.copy(this.dateModel));
				this.dateModel = moment(this.dateModel).date(this.dateModel.date());
				this.onDateChange({ date: this.dateModel });
			}
		});
		this.$scope.$watch('$ctrl.selectedDay', (newValue) => {
			if (newValue) {
				this.dateModel = moment(this.dateModel).date(newValue);
				this.onDateChange({ date: this.dateModel });
			}
		});
	}

	getLastDayOfMonth(date) {
		return new Date(moment(date).year(), moment(date).month() + 1, 0, 23, 59, 59).getDate();
	}
	updateMonthList() {
		this.months = MONTHS;

	}
	updateDaysList(date) {
		this.days = [];
		for (let i = 1; i <= this.getLastDayOfMonth(date); ++i) {
			this.days.push('' + i);
		}
		this.$timeout(()=>{
			if (this.$element.querySelector('select[name="nap"]+.accessible-select-wrapper')) {
				this.$element.querySelector('select[name="nap"]').nativeAccessibleSelect.render();
			}
		});
		this.selectedDay = '1';
	}

	updateYears() {
		let result = [];
		let min = this.minimumDate.isValid() ? this.minimumDate.year() : 1900;
		let max = this.maximumDate.isValid() ? this.maximumDate.year() : 2100;
		for (let i = min; i <= max; ++i) {
			result.push('' + i);
		}
		this.years = result;
	}
}

export default angular.module(MODULE_NAME, [])
	.component('datePicker', {
		controller: DatePickerController,
		template: datePickerTemplate(),
		bindings: {
			id: '@',
			dateModel: '<',
			minDate: '<',
			maxDate: '<',
			onDateChange: '&',
			mainLabel: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/common/components/date-picker.js